import {
  isBoolean,
  isDate,
  isEmpty,
  isEmptyArr,
  isNone,
  isNumber,
  isObject,
  isString,
} from 'iotera-base/object';
import React from 'react';
import { toDate } from '../../../../../lib/components/formatter';

import { safeGet } from 'iotera-base/json';

import '../alternative-style.css';

import Slide from '@material-ui/core/Slide';

export function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export function formatDatatype(inputType, input, uObjectClassName) {
  // if uObjectClassName is empty, className for other data (table)
  // if uObjectClassName is not empty, className for other uobject data (table)
  if (isNone(inputType)) {
    return '-';
  }
  let className = 'string-iotera-color';
  if (inputType === 'number') {
    if (isNone(uObjectClassName)) {
      className = 'number-iotera-color';
    } else {
      className = 'number-iotera-color' + ' ' + uObjectClassName;
    }
  } else if (inputType === 'boolean') {
    if (isBoolean(input)) {
      input = input ? 'true' : 'false';
    }
    if (isNone(uObjectClassName)) {
      className = 'boolean-iotera-color';
    } else {
      className = 'boolean-iotera-color' + ' ' + uObjectClassName;
    }
  } else if (inputType === 'datetime') {
    if (isNumber(input)) {
      input = toDate(input);
    }
    className = 'date-iotera-color';
  } else if (
    inputType === 'object' ||
    inputType === 'uobject' ||
    inputType === 'image' ||
    inputType === 'mobject' ||
    inputType === 'surveillance'
  ) {
    className = 'object-iotera-color';
  } else if (inputType === 'array') {
    className = 'date-iotera-color';
  }
  if (isNone(uObjectClassName)) {
    return <span className={className}>{input}</span>;
  } else {
    return (
      <>
        <span className={`${className} mr-1 key-iotera-color`}> : </span>
        <span className={className}> {input} </span>
      </>
    );
  }
}

export function formatDatatypeSelf(dt) {
  return formatDatatype(dt, dt);
}

export function formatSubparam(input) {
  if (isNone(input)) {
    return '-';
  }
  if (isObject(input)) {
    if (!isEmpty(input)) {
      let result = [];
      for (let key in input) {
        let value = input[key];
        result.push(
          <span>
            <span>
              <span className="key-iotera-color">{key}</span> :{' '}
            </span>
            {formatDatatypeSelf(value)}
          </span>
        );
        result.push(<br />);
      }
      return result;
    } else {
      return '-';
    }
  }
  return input;
}

export function formatValue(isFound, dt, value, subparamDatatypes) {
  if (isNone(value) || !isFound) {
    return '-';
  }
  if (dt === 'object') {
    if (isEmpty(value)) {
      return '-';
    }
    let result = [];
    for (let subparam in subparamDatatypes) {
      const subparamDatatype = subparamDatatypes[subparam];
      let subparamValue = safeGet(value, subparam, '-');
      result.push(
        <span>
          <span>
            <span className="key-iotera-color">{subparam}</span> :{' '}
          </span>
          {formatDatatype(subparamDatatype, subparamValue)}
        </span>
      );
      result.push(<br />);
    }
    return result;
  } else if (dt === 'uobject') {
    return '-';
  } else if (dt === 'image') {
    return '-';
  } else if (dt === 'array') {
    if (!isEmptyArr(value)) {
      let result = [];
      for (let i = 0; i < value.length; i++) {
        value = value[i];
        let className = 'string-iotera-color';
        if (isNumber(value)) {
          className = 'number-iotera-color';
        } else if (isBoolean(value)) {
          value = value ? 'true' : 'false';
          className = 'boolean-iotera-color';
        } else if (isDate(value)) {
          className = 'date-iotera-color';
        }
        if (i === value.length - 1) {
          result.push(
            <span>
              <span className={className}>{value}</span>
            </span>
          );
        } else {
          result.push(
            <span>
              <span className={className}>{value}, </span>
            </span>
          );
        }
      }
      return result;
    } else {
      return '-';
    }
  }
  return formatDatatype(dt, value);
}

export function formatValueTable(isFound, dt, value, subparamDatatypes) {
  if (isNone(value) || !isFound) {
    return '-';
  }
  if (dt === 'object') {
    if (isEmpty(value)) {
      return '-';
    }
    let result = [];
    for (let subparam in value) {
      const subparamValue = value[subparam];
      let subparamDatatype = safeGet(subparamDatatypes, subparam, 'text');
      result.push(
        <span>
          <span>
            <span className="key-iotera-color">{subparam}</span> :{' '}
          </span>
          {formatDatatype(subparamDatatype, subparamValue)}
        </span>
      );
      result.push(<br />);
    }
    return result;
  } else if (dt === 'uobject') {
    return '-';
  } else if (dt === 'image') {
    return '-';
  } else if (dt === 'array') {
    if (!isEmptyArr(value)) {
      let result = [];
      for (let i = 0; i < value.length; i++) {
        value = value[i];
        let className = 'string-iotera-color';
        if (isNumber(value)) {
          className = 'number-iotera-color';
        } else if (isBoolean(value)) {
          value = value ? 'true' : 'false';
          className = 'boolean-iotera-color';
        } else if (isDate(value)) {
          className = 'date-iotera-color';
        }
        if (i === value.length - 1) {
          result.push(
            <span>
              <span className={className}>{value}</span>
            </span>
          );
        } else {
          result.push(
            <span>
              <span className={className}>{value}, </span>
            </span>
          );
        }
      }
      return result;
    } else {
      return '-';
    }
  }
  return formatDatatype(dt, value);
}

export function formatDate(isFound, date) {
  if (isNone(date) || !isFound) {
    return '-';
  }
  return toDate(date);
}

export function formatValueUObject(value) {
  let type;
  let classNameValueUObject = 'font-size-json-formatter ml-0';
  let classNames = 'string-iotera-color' + ' ' + classNameValueUObject;
  // checking for true or false come back to boolean, cause library returning true or false to be string.
  if (value === 'true') {
    value = true;
  } else if (value === 'false') {
    value = false;
  }
  // end checking
  if (isNone(value)) type = null;
  else if (isString(value)) type = 'string';
  else if (isBoolean(value)) type = 'boolean';
  else if (isNumber(value)) type = 'number';
  if (type === 'string') {
    value = value.substring(1, value.length - 1);
    return (
      <>
        <span className={`${classNames} mr-1 key-iotera-color`}> : </span>
        <span className={classNames}> {value} </span>
      </>
    );
  } else return formatDatatype(type, value, classNameValueUObject);
}

export function formatLabelUObject(key) {
  return (
    <span className="key-iotera-color font-size-json-formatter mr-0">
      {' '}
      {key}{' '}
    </span>
  );
}

export function formatItemStringUObject(type, data, itemType, itemString) {
  let itemStringCustom = '';
  for (let i in itemString) {
    if (itemString[i] !== ' ') {
      itemStringCustom += itemString[i];
    } else if (itemString[i] === ' ') {
      break;
    }
  }
  if (type === 'Object') {
    itemStringCustom = `{${itemStringCustom}}`;
  } else if (type === 'Array') {
    itemStringCustom = `[${itemStringCustom}]`;
  }
  return <span> {itemStringCustom} </span>;
}

export function selectKeyUObject(item) {
  return '{}';
}
